<template>
    <canvas ref="myBullsI"></canvas>
</template>

<script>
    import { sync } from 'vuex-pathify';

    export default {
        computed: {
            myBullsI: sync('myBullsI')
        },
        mounted() {
            const image = new Image();
            image.src = require('@/assets/MyBulls-i/bullsi_blank.png');
            image.onload = () => {
                this.$nextTick(() => {
                    const canvas = this.$refs.myBullsI;
                    canvas.width = window.innerWidth - 32;
                    canvas.height = 399;

                    const context = canvas.getContext('2d');
                    context.drawImage(image, 0, 0, 211, 399);

                    context.fillStyle = 'black';
                    context.font = 'bold 14px Roboto';
                    const x = 158;
                    let y = 251;
                    this.myBullsI.forEach((prompt, index) => {
                        context.fillText(prompt.response, x, y);
                        if (1 === index) {
                            y += 32;
                        } else {
                            y += 31;
                        }
                    });
                });
            };
        }
    };
</script>
